export const PARTNERS_GUID_ENUM = {
  KTDA: 'kymbritam',
  ATLEHANG: 'atlehangguid',
  KONYANA: 'konyanaguid',
  MANANKIFIN: 'manankifinguid',
  ACCESS_BANK: 'accessbank',
  BBOX_KENYA: 'bboxxkeguid',
  BBOX_RWANDA: 'bboxxrwguid',
  ORANGE: 'orangeguid',
  INSOLCOMPLEX: 'insolguid',
  FAITH_FUNERALS: 'faithfuneralsguid',
  PREMIER_CREDIT_ZAMBIA: 'premcredzamguid',
  AIRTEL_ZAMBIA: 'airtelzambia',
  ASPIN_PLUS: 'aspinplus',
  NGS_UGANDA: 'ngsugguid',
  AIRTEL_MALAWI: 'airtelmalawiguid',
  REAL_PEOPLE: 'realpeopleguid',
  SHIPRAZOR_SOUTH_AFRICA: 'shiprazor_sa_guid',
  SHIPRAZOR_KENYA: 'shiprazor_ke_guid',
  INCL_MOTOR: 'incl_motor',
  EUNIFIN_GHANA: 'eunifingh',
  EUNIFIN_SENEGAL: 'eunifinsn',
  MALIPOWWS: 'malipo_wws',
  HEALTH_ENTREPRENEURS: 'he_chp',
  OLDMUTUAL_UGANDA_POSTBANK: 'omu_posbank',
  OLDMUTUAL_CENTENARY_BANK: 'centenary_bank',
  OLDMUTUAL_DFCU_UG: 'dfcu_ug',
  OLDMUTUAL_UGANDA_ROTARY: 'om_rotary',
  OLDMUTUAL_UGANDA_NAMIREMBE: 'om_namirembe',
  COVER_LINK: 'cover_link',
  MZANU: 'banja',
  OLDMUTUAL_UGANDA_FLP: 'omu_flp',
  OLDMUTUAL_KENYA: 'omk',
  SENTI: 'senti_ke',
  OLDMUTUAL_UGANDA_LIONSCLUB: 'om_lions',
  OLDMUTUAL_MALAWI: 'old_mutual_malawi',
  SAMBA: 'samba',
  marketplace_a: 'marketplace_a',
  marketplace_b: 'marketplace_b',
  marketplace_c: 'marketplace_c',
  MMI_GHANA: 'MMI_Ghana',
}

export const CLAIM_TAG_PARTNERS = [PARTNERS_GUID_ENUM.KTDA]

export const PARTNERS_WITH_POLICY_NUMBER_SPECIAL_CHARACTORS = [
  PARTNERS_GUID_ENUM.NGS_UGANDA,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP,
  PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK,
  PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB
]

// Cause of death, location of death and the chronic-condition/hospitalisation
// answers are captured at claim initiation. The claim assessment view has always
// rendered these fields; without capture they read "N/A" to the assessor.
export const PARTNERS_WITH_CAUSE_OF_DEATH_CAPTURE = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG
]

// Claimant relationships beyond the Self/Spouse/Son/Daughter set, for products
// whose cover extends to parents and in-laws.
export const PARTNERS_WITH_EXTENDED_CLAIMANT_RELATIONSHIPS = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG
]

// The selling agent is already on the policy record, so re-capturing one at claim
// time only invites the two to disagree.
// A member dies once: one death claim per member per policy.
export const PARTNERS_WITH_SINGLE_DEATH_CLAIM = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG
]

// A police abstract/OB report and medical/hospital report are listed on every
// death claim, and required when the death was accidental.
export const PARTNERS_WITH_ACCIDENTAL_DEATH_EVIDENCE = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG
]

export const PARTNERS_REQUIRING_CLAIM_REJECTION_REASON = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG
]

export const PARTNERS_WITH_CLAIM_AUDIT = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG
]

export const PARTNERS_WITHOUT_CLAIM_AGENT_CAPTURE = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK,
  PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG
]

export const PARTNERS_WITH_OLD_COMPLEX_UI = [
  PARTNERS_GUID_ENUM.KTDA,
  PARTNERS_GUID_ENUM.MANANKIFIN,
  PARTNERS_GUID_ENUM.KONYANA,
  PARTNERS_GUID_ENUM.FAITH_FUNERALS
]

export const PARTNERS_WITH_RECENT_POLICIES = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK,
  PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK,
  PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE,
  PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA,
  PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI,
  PARTNERS_GUID_ENUM.SAMBA
]

// Partners that intentionally allow a customer to hold multiple active
// policies simultaneously. Scoped to the manual policy approval flow so the
// duplicate active-policy pre-check is skipped for these partners only.
export const PARTNERS_ALLOWING_MULTIPLE_ACTIVE_POLICIES = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI,
  PARTNERS_GUID_ENUM.SAMBA
]

export const PARTNERS_WITH_RECENT_PAYMENTS = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK,
  PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK,
  PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE,
  PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA,
  PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI
]

export const REMOVE_PREMIUM_ALLOWED_PARTNERS = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK,
  PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK,
  PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE,
  PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA
]

export const TRANSFER_POLICY_ALLOWED_PARTNERS = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_POSTBANK,
  PARTNERS_GUID_ENUM.OLDMUTUAL_CENTENARY_BANK,
  PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_FLP,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_LIONSCLUB,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_ROTARY,
  PARTNERS_GUID_ENUM.OLDMUTUAL_UGANDA_NAMIREMBE,
  PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA,
  PARTNERS_GUID_ENUM.OLDMUTUAL_MALAWI
]

// The screening engine that scores a customer and writes customer_risk_rating
// onto additional_details runs for these partners only. Elsewhere flagged
// policies carry no rating, so the flag dashboards must not narrow by one.
export const PARTNERS_WITH_CUSTOMER_RISK_RATING = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA
]

// Partners whose Quotes tab lists every quotation on the policy — an amendment
// creates a new one — instead of the single quotation attached to it.
export const PARTNERS_WITH_POLICY_QUOTATION_LIST = [
  PARTNERS_GUID_ENUM.OLDMUTUAL_KENYA,
  PARTNERS_GUID_ENUM.OLDMUTUAL_DFCU_UG
]
